export default __webpack_public_path__ + "static/media/Blog_Post_3.77b2be85.jpg";